import { getRouteAbout, getRouteVacancies } from "../../../shared/constants/routes";

const navigationFooter = [
    {
        name: "Все вакансии",
        to: getRouteVacancies(),
    },
    {
        name: "Ценности",
        to: "/about/#values",
    },
    {
        name: "Достижения",
        to: "/about/#achievements",
    },
    {
        name: "О компании",
        to: getRouteAbout(),
    },
    {
        name: "Наши преимущества",
        to: "/#energy",
    },
    {
        name: "История БКС",
        to: "/about/#history",
    },
];

export default navigationFooter;
